export interface SliderMap {
  [key: string]: number;
}

export const findNearestPercentage = ({
  sliderMap,
  startPercentage,
  currentX
}: {
  sliderMap: SliderMap;
  startPercentage: number;
  currentX: number;
}) => {
  if (Object.keys(sliderMap).length > 0) {
    const result = Object.entries(sliderMap).reduce(
      (agg, curr: [string, number]) => {
        const [key, percent] = curr;

        const difference = Math.abs(currentX - Number(key));
        if (
          difference < agg.difference ||
          (difference === agg.difference && percent < agg.percent)
        ) {
          return {
            key,
            percent: percent,
            difference
          };
        }

        return agg;
      },
      { key: "", percent: 100, difference: Number.MAX_SAFE_INTEGER }
    );

    if (result.percent <= startPercentage) {
      return result.percent;
    }
  }
  return startPercentage;
};

export const buildSliderMap = (sliderRect: ClientRect): SliderMap => {
  const increment = (sliderRect.right - sliderRect.left) / 10;

  return {
    [sliderRect.left]: 0,
    [sliderRect.left + increment]: 10,
    [sliderRect.left + increment * 2]: 20,
    [sliderRect.left + increment * 3]: 30,
    [sliderRect.left + increment * 4]: 40,
    [sliderRect.left + increment * 5]: 50,
    [sliderRect.left + increment * 6]: 60,
    [sliderRect.left + increment * 7]: 70,
    [sliderRect.left + increment * 8]: 80,
    [sliderRect.left + increment * 9]: 90,
    [sliderRect.left + increment * 10]: 100
  };
};

export const getTransparentImage = () => {
  var img = new Image();
  img.src =
    "data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=";
  return img;
};
